import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React, { useEffect, useState } from "react";
import { fAlertToast } from "../../../Utility/Utilitys";
import axios from "axios";
import { getGlobals } from "../../../Configs";
import { useMemo } from "react";

const AllocationItemModal = ({ open, data, itemData }) => {
  const [loadingAction, setLoadingAction] = useState(false);
  const [detailData, setDetailData] = useState([]);
  const baseURL = getGlobals().API_BASE_URL;

  const handleAllocation = async () => {
    setLoadingAction(true);
    try {
      const payload = {
        VocTyp: data?.A_VocTyp,
        VocNo: data?.A_VocNo,
        ItmCd: itemData?.RP_ItmCd,
      };
      const result = await axios.post(
        `${baseURL}PurchaseOrder/PUCNS01CONSLLocItems_Loc_GETROW`,
        payload
      );
      console.log(result);

      if (result.status === 200) {
        // if(result?.result?.recordset?.length >0){
        console.log("dataret54", result?.data?.data?.summary);
        let GridID = result?.data?.data?.summary?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setDetailData(GridID);
        // setApiResponse(data?.data?.data || []);
      }
    } catch (error) {
      console.error("API Error:", error);
      fAlertToast("FAILED", error?.response?.data?.message || error?.message);
      setDetailData({ status: "error", message: "Failed to fetch data." });
    } finally {
      setLoadingAction(false);
    }
  };
  console.log("deeeeeee", detailData);

  const handleKeyDown = (e) => {
    stopGridArrowNavigation(e);
    if (e.key === " ") e.stopPropagation();
  };

  const fSave = async () => {
    try {
      const iArray = detailData?.map((item) => ({
        IL_Loc: item?.IL_Loc,
        IL_LocName: item?.IL_LocName,
        IL_BalQty: item?.IL_BalQty,
        PackQty: item?.PackQty,
        IL_Pur_Alloc_Qty: item?.IL_Pur_Alloc_Qty,
        IL_Pur_Alloc_BaseQty: item?.IL_Pur_Alloc_BaseQty,
      }));
      const payload = {
        vocTyp: data?.A_VocTyp,
        vocNo: data?.A_VocNo,
        itmCd: itemData?.RP_ItmCd,
        details: iArray,
      };
      const result = await axios.post(
        `${baseURL}PurchaseOrder/PUCNS01CONSLLocItems_Manual_Allocation`,
        payload
      );
      console.log(result);

      if (result.status === 200) {
        fAlertToast("SUCCESS", "Saved Successfully");
      }
    } catch (error) {
      console.error("API Error:", error);
      fAlertToast(
        "FAILED",
        error?.response?.data?.error || error?.message || error?.message
      );
    } finally {
      setLoadingAction(false);
    }
  };

  const numFmt = (p) =>
    p?.value == null
      ? ""
      : Number(p.value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

  const totalAllocatedQty = useMemo(() => {
    return detailData?.reduce(
      (sum, row) => sum + parseFloat(row.IL_Pur_Alloc_Qty || 0),
      0
    );
  }, [detailData]);

  useEffect(() => {
    if (open) {
      handleAllocation();
    }
  }, [open]);

  return (
    <div>
      <Grid container spacing={0.5}>
        <Grid item xs={12} sm={12} md={12}>
          <Grid container>
            <Grid item xs={4} sm={2.5} md={1.8} lg={1.3}>
              <Typography
                variant="subtitle2"
                color={"primary.main"}
                fontWeight={600}
              >
                Item
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} md={0.3} lg={0.3}>
              <Typography
                variant="subtitle2"
                color={"primary.main"}
                fontWeight={600}
              >
                :
              </Typography>
            </Grid>
            <Grid item xs={7.5} sm={9} md={9.1} lg={10.4}>
              <Typography variant="subtitle2" fontWeight={600}>
                {itemData?.RP_ItmCd} - {itemData?.RP_ItmName}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid container>
            <Grid item xs={4} sm={2.5} md={1.8} lg={1.3}>
              <Typography
                variant="subtitle2"
                color={"primary.main"}
                fontWeight={600}
              >
                Request Qty
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} md={0.3} lg={0.3}>
              <Typography
                variant="subtitle2"
                color={"primary.main"}
                fontWeight={600}
              >
                :
              </Typography>
            </Grid>
            <Grid item xs={7.5} sm={9} md={9.1} lg={10.4}>
              <Typography variant="subtitle2" fontWeight={600}>
                {itemData?.RP_RequestQty}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid container>
            <Grid item xs={4} sm={2.5} md={1.8} lg={1.3}>
              <Typography
                variant="subtitle2"
                color={"primary.main"}
                fontWeight={600}
              >
                Purchased Qty
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} md={0.3} lg={0.3}>
              <Typography
                variant="subtitle2"
                color={"primary.main"}
                fontWeight={600}
              >
                :
              </Typography>
            </Grid>
            <Grid item xs={7.5} sm={9} md={9.1} lg={10.4}>
              <Typography variant="subtitle2" fontWeight={600}>
                {itemData?.RP_PurchasedQty}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid container>
            <Grid item xs={4} sm={2.5} md={1.8} lg={1.3}>
              <Typography
                variant="subtitle2"
                color={"primary.main"}
                fontWeight={600}
              >
                DC Reserved Qty
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} md={0.3} lg={0.3}>
              <Typography
                variant="subtitle2"
                color={"primary.main"}
                fontWeight={600}
              >
                :
              </Typography>
            </Grid>
            <Grid item xs={7.5} sm={9} md={9.1} lg={10.4}>
              <Typography variant="subtitle2" fontWeight={600}>
                {itemData?.RP_DCReserved}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid container>
            <Grid item xs={4} sm={2.5} md={1.8} lg={1.3}>
              <Typography
                variant="subtitle2"
                color={"primary.main"}
                fontWeight={600}
              >
                Qty
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} md={0.3} lg={0.3}>
              <Typography
                variant="subtitle2"
                color={"primary.main"}
                fontWeight={600}
              >
                :
              </Typography>
            </Grid>
            <Grid item xs={7.5} sm={9} md={9.1} lg={10.4}>
              <Typography variant="subtitle2" fontWeight={600}>
                {itemData?.Qty}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid container>
            <Grid item xs={4} sm={2.5} md={1.8} lg={1.3}>
              <Typography
                variant="subtitle2"
                color={"primary.main"}
                fontWeight={600}
              >
                Pack Qty
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} md={0.3} lg={0.3}>
              <Typography
                variant="subtitle2"
                color={"primary.main"}
                fontWeight={600}
              >
                :
              </Typography>
            </Grid>
            <Grid item xs={6.5} sm={8} md={8.1} lg={9.4}>
              <Typography variant="subtitle2" fontWeight={600}>
                {itemData?.RP_PackQty}
              </Typography>
            </Grid>
            <Grid item xs={1} sm={1} md={1} lg={1}>
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={() => fSave()}
                sx={{ marginRight: 1 }}
                disabled={data?.Allocated === "POST"}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box sx={{ height: "58vh", marginTop: "10px" }}>
        <DataGridPro
          loading={loadingAction}
          rows={detailData}
          columns={[
            {
              field: "IL_LocName",
              headerName: "Location",
              minWidth: 140,
              flex: 1,
            },

            {
              field: "IL_BalQty",
              headerName: "Request",
              width: 120,
              type: "number",
              align: "center",
              headerAlign: "center",
            },
            {
              field: "PackQty",
              headerName: "Pack Qty",
              width: 120,
              type: "number",
              align: "center",
              headerAlign: "center",
            },
            {
              field: "IL_Pur_Alloc_Qty",
              headerName: "Allocated Qty",
              width: 120,
              type: "number",
              align: "center",
              headerAlign: "center",
              sortable: false,
              cellClassName: "editable-cell",
              renderCell: (params) => {
                return (
                  <TextField
                    value={params.value ?? ""}
                    onChange={(e) => {
                      const newValue = e?.target?.value ?? "";

                      setDetailData((prevRows) =>
                        prevRows.map((row) => {
                          if (row.id === params.row.id) {
                            const packQty = parseFloat(row.PackQty ?? 0);
                            const alloQty =
                              newValue === "" ? 0 : parseFloat(newValue ?? 0); // 👈 handle empty
                            return {
                              ...row,
                              IL_Pur_Alloc_Qty: newValue,
                              IL_Pur_Alloc_BaseQty: packQty * alloQty, // 👈 0 if empty
                            };
                          }
                          return row;
                        })
                      );
                    }}
                    disabled={data?.Allocated === "POST"}
                    inputProps={{
                      inputMode: "decimal",
                      type: "number",
                      step: "any",
                      min: 0,
                    }}
                    autoComplete="off"
                    sx={{
                      width: 100,
                      "& .MuiOutlinedInput-input": {
                        textAlign: "center",
                        padding: "4px 6px",
                        fontSize: "12px",
                      },
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "6px",
                        height: "26px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "lightgray",
                      },
                    }}
                    size="small"
                    variant="outlined"
                    onKeyDown={handleKeyDown}
                    onWheel={(e) => e.target.blur()} // prevent scroll changing value
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                    onFocus={(e) => e.stopPropagation()}
                    tabIndex={-1}
                  />
                );
              },
            },
            {
              field: "IL_Pur_Alloc_BaseQty",
              headerName: "Allocated Base Qty",
              width: 130,
              type: "number",
              align: "center",
              headerAlign: "center",
              valueFormatter: numFmt,
              cellClassName: "readonly2-cell",
            },
          ]}
          getRowId={(row) => row.id}
          disableRowSelectionOnClick
          hideFooterSelectedRowCount
          hideFooterPagination
          components={{
            Footer: () => (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "8px 16px",
                  backgroundColor: "#f5f5f5",
                  borderTop: "1px solid #ddd",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    marginRight: 1,
                    color: "#333",
                  }}
                >
                  Total Allocated Qty:
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {totalAllocatedQty.toFixed(2)}
                </Typography>
              </Box>
            ),
          }}
          columnHeaderHeight={32}
          rowHeight={32}
          headerHeight={40}
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-cell": {
              padding: "4px",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: "12px",
              textAlign: "center",
            },
            "& .readonly2-cell": {
              backgroundColor: "#d4e9ff",
            },
            "& .editable-cell": {
              backgroundColor: "#edfaff",
              border: "1px solid lightgray",
            },
            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
              color: "#24292e",
            },
            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.Mui-checked":
              {
                color: "#0298f5",
              },

            "& .MuiDataGrid-row.reject-row": {
              backgroundColor: "#ffe5e5 !important",
            },
          }}
        />
      </Box>
    </div>
  );
};

export default AllocationItemModal;

const stopGridArrowNavigation = (e) => {
  const blocked = [
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
    "PageUp",
    "PageDown",
  ];
  if (blocked.includes(e.key)) e.stopPropagation();
};
